import React, { useEffect, useState } from 'react'

import Drawer from '@material-ui/core/Drawer'

import usePostData from 'hooks/post-data'

import { FormTitle } from 'components/Maintainance/components'
import { MinimalAutoComplete, MinimalInput } from 'components/Assets/components'
import { MinimalButtonGroup, MinimalButton } from 'components/common/buttons'

import facilities from 'Services/facilities/index'

import { get, isEmpty } from 'lodash'
import * as yup from 'yup'
import { validateSchema } from 'helpers/schemaValidation'
import { filterNumberValue, statusOptions } from './utils'

const AddClientCompany = ({ open, onClose, isEdit, reFetch, anchorObj, stateData, branchData, clientBranchId }) => {
  const [companyData, setCompanyData] = useState({
    clientCompanyName: '',
    status: 1,
    clientCompanyCode: '',
    owner: '',
    ownerAddress: '',
    ownerAddress2: '',
    stateId: null,
    companybranchId: null,
    city: '',
    zip: '',
  })
  const [error, setError] = useState('')
  const [branchList, setBranchList] = useState([])

  const handleInputChange = (name, value) => {
    setCompanyData({ ...companyData, [name]: value })
  }

  const validateForm = async () => {
    const schema = yup.object().shape({
      clientCompanyName: yup.string().required('Client Company Name is required !'),
      clientCompanyCode: yup.string().required('Client Company Code is required !'),
      owner: yup.string().required('Owner Name is required !'),
      ownerAddress: yup.string().required('Owner Address is required !'),
      companybranchId: yup.string().required('Branch is required !'),
      zip: yup.string().max(6, 'Please enter a valid ZIP code !').nullable(),
    })
    const playload = { ...companyData, companybranchId: get(companyData, 'companybranchId.value', '') }
    const isValid = await validateSchema(playload, schema)
    setError(isValid)
    if (isValid === true) submitData(playload)
  }

  const postSuccess = () => {
    onClose()
    reFetch()
  }

  const { loading: isLoading, mutate: clientCompany } = usePostData({ executer: facilities.company.create, postSuccess, message: { success: !isEdit ? 'Client Company Create Successfully!' : 'Client Company Updated Successfully!', error: 'Something went wrong' } })
  const submitData = async payload => clientCompany({ ...payload, status: companyData.status, clientCompanyId: !isEdit ? null : anchorObj.clientCompanyId, stateId: get(companyData, 'stateId.stateId', null) })

  useEffect(() => {
    if (isEdit) {
      let stateIdValue = get(anchorObj, 'stateId', null)
      let companybranchId = clientBranchId && !isEmpty(branchList) ? branchList.find(d => d.value == clientBranchId) || null : null
      let stateId = stateIdValue && !isEmpty(stateData) ? stateData.find(d => d.value === stateIdValue) || null : null

      setCompanyData({
        clientCompanyName: get(anchorObj, 'clientCompanyName', ''),
        status: get(anchorObj, 'status', 1),
        clientCompanyCode: get(anchorObj, 'clientCompanyCode', ''),
        owner: get(anchorObj, 'owner', ''),
        ownerAddress: get(anchorObj, 'ownerAddress', ''),
        ownerAddress2: get(anchorObj, 'ownerAddress2', ''),
        stateId: stateId,
        companybranchId: companybranchId,
        city: get(anchorObj, 'city', null),
        zip: get(anchorObj, 'zip', null),
      })
    } else if (!get(companyData, 'companybranchId', null)) {
      let companybranchId = clientBranchId && !isEmpty(branchList) ? branchList.find(d => d.value == clientBranchId) || null : null
      setCompanyData({ ...companyData, companybranchId: companybranchId })
    }
  }, [isEdit, anchorObj, branchList])

  useEffect(() => {
    let sortedList = []
    if (!isEmpty(branchData)) {
      sortedList = branchData.map(item => ({
        label: item.companyBranchName,
        value: item.companybranchId,
      }))
    }
    setBranchList(sortedList)
  }, [branchData])

  return (
    <Drawer anchor='right' open={open} onClose={onClose}>
      <FormTitle title={!isEdit ? 'Add Client Company' : 'Edit Client Company'} style={{ width: '100%', minWidth: '500px' }} closeFunc={onClose} />
      <div className='table-responsive dashboardtblScroll' id='style-1' style={{ maxHeight: 'calc(100vh - 65px)', height: 'calc(100vh - 65px)', background: '#efefef', width: '500px' }}>
        <div style={{ padding: '10px' }}>
          <div style={{ padding: '16px', background: '#fff', borderRadius: '4px' }}>
            <MinimalAutoComplete placeholder='Select Branch' value={get(companyData, 'companybranchId', '') || ''} onChange={value => handleInputChange('companybranchId', value)} options={branchList} label='Branch' isClearable w={100} error={error.companybranchId} onFocus={() => setError({ ...error, companybranchId: null })} />
            <MinimalInput value={get(companyData, 'clientCompanyName', '') || ''} onChange={value => handleInputChange('clientCompanyName', value)} error={error.clientCompanyName} onFocus={() => setError({ ...error, clientCompanyName: null })} label='Client Company Name' placeholder='Enter Client Company Name' w={100} />
            <MinimalInput value={get(companyData, 'clientCompanyCode', '') || ''} onChange={value => handleInputChange('clientCompanyCode', value)} error={error.clientCompanyCode} onFocus={() => setError({ ...error, clientCompanyCode: null })} label='Client Company Code' placeholder='Enter Client Company Code' w={100} />
            <MinimalButtonGroup label='Status' value={get(companyData, 'status', 1) || 1} onChange={value => handleInputChange('status', value)} options={statusOptions} w={100} />
            <MinimalInput value={get(companyData, 'owner', '') || ''} onChange={value => handleInputChange('owner', value)} label='Owner Name' error={error.owner} onFocus={() => setError({ ...error, owner: null })} placeholder='Enter Owner Name' w={100} />
            <MinimalInput value={get(companyData, 'ownerAddress', '') || ''} onChange={value => handleInputChange('ownerAddress', value)} label='Address Line 1' error={error.ownerAddress} onFocus={() => setError({ ...error, ownerAddress: null })} placeholder='Enter Address Line 1' w={100} />
            <MinimalInput value={get(companyData, 'ownerAddress2', '') || ''} onChange={value => handleInputChange('ownerAddress2', value)} label='Address Line 2' error={error.ownerAddress2} onFocus={() => setError({ ...error, ownerAddress2: null })} placeholder='Enter Address Line 2' w={100} />
            <MinimalInput value={get(companyData, 'city', '') || ''} onChange={value => handleInputChange('city', value)} label='City' error={error.city} onFocus={() => setError({ ...error, city: null })} placeholder='Enter City' w={100} />
            <div className='d-flex flex-row'>
              <MinimalAutoComplete placeholder='Enter State' value={get(companyData, 'stateId', null) || null} onChange={value => handleInputChange('stateId', value)} options={stateData} label='State' isClearable w={100} />
              <MinimalInput value={get(companyData, 'zip', '') || ''} onChange={value => handleInputChange('zip', filterNumberValue(value))} label='Zip' error={error.zip} onFocus={() => setError({ ...error, zip: null })} placeholder='Enter Zip' w={100} baseStyles={{ marginRight: '0px' }} />
            </div>
            {/* <MinimalTextArea rows={3} value={get(companyData, 'ownerAddress', '') || ''} onChange={e => handleInputChange('ownerAddress', e.target.value)} error={error.ownerAddress} onFocus={() => setError({ ...error, ownerAddress: null })} placeholder='Enter Owner Address' label='Owner Address' w={100} baseStyles={{ marginBottom: 0 }} /> */}
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-between align-items-center' style={{ borderTop: '1px solid #A6A6A6', borderBottom: 'none', background: '#fff', marginTop: 'auto', padding: '12px' }}>
        <MinimalButton variant='contained' color='default' text='Cancel' onClick={onClose} />
        <MinimalButton variant='contained' color='primary' text={!isEdit ? 'Add' : 'Update'} loadingText={!isEdit ? 'Adding...' : 'Updating...'} onClick={validateForm} disabled={isLoading} loading={isLoading} style={{ marginLeft: '10px' }} />
      </div>
    </Drawer>
  )
}

export default AddClientCompany
